import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import OverviewTab from "@/components/monitor/Overview";
import ResourcesTab from "@/components/monitor/Resources";
import PerformanceTab from "@/components/monitor/Performance";
import { DbTab, ApiTab } from "@/components/monitor/DbApi";
import CdnTab from "@/components/monitor/Cdn";
import ErrorsTab from "@/components/monitor/Errors";
import AlarmsTab from "@/components/monitor/Alarms";
import TestsTab from "@/components/monitor/Tests";

const TABS = [
  ["overview", "Genel Durum", OverviewTab], ["resources", "Sunucu Kaynakları", ResourcesTab], ["performance", "Performans Grafikleri", PerformanceTab],
  ["db", "Veritabanı İzleme", DbTab], ["api", "API Performansı", ApiTab], ["cdn", "CDN ve Görsel Optimizasyonu", CdnTab],
  ["errors", "Sistem Hataları", ErrorsTab], ["alarms", "Alarm ve Bildirim Ayarları", AlarmsTab], ["tests", "Testler ve Raporlar", TestsTab],
];

export default function MonitoringPage() {
  return (
    <div className="space-y-6" data-testid="monitoring-page">
      <div>
        <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold mb-1">Super Admin</div>
        <h1 className="text-4xl font-extrabold tracking-tight text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>Sistem İzleme</h1>
        <p className="text-slate-500 mt-1">Sunucu, veritabanı, API, CDN ve alarm durumu. Tüm değerler gerçek ölçümlerden gelir; alınamayan metrikler açıkça belirtilir.</p>
      </div>
      <Tabs defaultValue="overview">
        <TabsList className="h-auto">
          {TABS.map(([v, l]) => <TabsTrigger key={v} value={v} data-testid={`monitor-tab-${v}`}>{l}</TabsTrigger>)}
        </TabsList>
        {TABS.map(([v, , C]) => <TabsContent key={v} value={v} className="mt-5"><C /></TabsContent>)}
      </Tabs>
    </div>
  );
}
